import { AbstractSearchableSelector } from 'common/components/Input/AbstractSearchableSelector';
import {
  IBitecoinRewardCategoryCollectionFilter,
  IBitecoinRewardCategoryModel,
} from 'entities/Bitecoin/Bitecoin.models';
import { bitecoinTransport } from 'entities/Bitecoin/Bitecoin.transport';

export class BitecoinRewardCategorySelector extends AbstractSearchableSelector<IBitecoinRewardCategoryModel, {}> {
  getItemLabel = (item: IBitecoinRewardCategoryModel) => {
    return item.name;
  };

  loadData = (value?: string) => {
    const filterParams: IBitecoinRewardCategoryCollectionFilter = {};

    if (value) {
      filterParams.search = value;
    }

    return bitecoinTransport.getBitecoinRewardCategoryCollection(filterParams);
  };
}
